/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(document).ready(function(){
  
  function showHideAvailabilityMsg(){
    if($('.Select--primary select').find('option:selected').prop('disabled') || (typeof forceShowMsg != "undefined" && forceShowMsg)){
      $('.out-of-stock-msg').show();
    }else{
      $('.out-of-stock-msg').hide();
    }
  }
  
  function resizeFilterColumn(){
    if($('.Product').length){
      setTimeout(function(){
        //var ht = $(window).height() - $('.CollectionInner__Sidebar')[0].getBoundingClientRect().top - $('.CollectionToolbar').outerHeight() - 20;
        //$('.CollectionFilters').css('overflow','auto').height(ht);
      },500);
    }
  }
  
  $('.Select--primary select').change(function(){
    showHideAvailabilityMsg();
  });
  $(window).resize(function(){
    resizeFilterColumn();
  });
  $(window).scroll(function(){
    resizeFilterColumn();
  });
  
  showHideAvailabilityMsg();
  resizeFilterColumn();
  
  setTimeout(function(){
    if($('.shopify-challenge__container').length){
      $('html,body').animate({scrollTop: $('#main').position().top-$('#section-header').outerHeight()-50},300);
    }
  },1000);
  
  /****** Video feature *****/
  $('.img-list-item a').click(function(){
    if($(this).hasClass('cloud-zoom-gallery')){
      $('.product-img-box .product-image').show();
      $('.product-img-box .product-video-container').hide().html('');
    }else{
      $('.product-img-box .product-image').hide();
      $('.product-img-box .product-video-container').html(unescape($(this).data('content'))).show();
      var containerWidth = $('.product-img-box .product-video-container').width();
      var aspectRatio = $(this).data('ratio');
      $('.product-img-box .product-video-container *:first-child').width(containerWidth).height(containerWidth/aspectRatio); 
    }
  });
  $('.img-list-item a').first().click();
  
});